import ReferenceInterface from '../../interfaces/client/Reference'

export const ADD_PASSENGER_REFERENCES = 'ADD_PASSENGER_REFERENCES'

export default (references: ReferenceInterface) => ({
  type: ADD_PASSENGER_REFERENCES,
  references,
})
